export const generateImageName = (index = 0) => {
  return `${new Date().getTime()}${index}`;
};

export const sleep = async (t) => {
  return new Promise((s) => setTimeout(s, t));
};
